import Icon from '@components/v2/ui/Icon/Icon';
import { ButtonBase } from '@mui/material';
import classNames from 'classnames';
import { Check, X } from 'lucide-react';
import LangEnum from '../../../../../../lang/LangEnum';
import { AllowChangeGrid } from '../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { ProductGridTestIds } from '../../../../../../utils/testIds/productGrid.testIds';
import { packDisallowChange } from '../../../../../grids/utils/packs.utils';
import { AvailabilityEnum } from '../../../../../products/ProductTypes';
import { useTranslation } from '../../../../../translation/TranslationContext';
import useOrderProductGridButtonStyles from '../../grid/components/orderProductGrid/components/buttons/styles/useOrderProductGridButtonStyles';
import ButtonOnNoUnableToPaste from './ButtonOnNoUnableToPaste';
import { CopyOrPasteStatusEnum } from './copyPaste.types';

interface CopyOrPasteButtonProps {
  availability: AvailabilityEnum;
  allowChangePreOrderGrid?: AllowChangeGrid;
  allowChangeImmediateGrid?: AllowChangeGrid;
  copyOrPaste: CopyOrPasteStatusEnum;
  disablePaste?: boolean;
  onClickPaste: () => void;
  removeCopiedGrid: () => void;
}

const CopyOrPasteButton = ({
  allowChangeImmediateGrid,
  allowChangePreOrderGrid,
  availability,
  onClickPaste,
  copyOrPaste,
  removeCopiedGrid,
  disablePaste,
}: CopyOrPasteButtonProps) => {
  const { classes } = useOrderProductGridButtonStyles();

  const { translate } = useTranslation();

  const disablePasteAction =
    disablePaste ||
    packDisallowChange(availability, allowChangePreOrderGrid, allowChangeImmediateGrid);

  switch (copyOrPaste) {
    case CopyOrPasteStatusEnum.ON_PASTED_GRID:
      return (
        <ButtonBase
          disableRipple
          disabled
          tabIndex={-1}
          className={classNames(classes.button, classes.pastedButton)}
        >
          <Icon icon={Check} size="md" className={classes.pastedIcon} />
          {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_PASTED)}
        </ButtonBase>
      );
    case CopyOrPasteStatusEnum.ON_PASTE_ACTION:
      return disablePasteAction ? (
        <ButtonOnNoUnableToPaste />
      ) : (
        <ButtonBase
          disableRipple
          onClick={onClickPaste}
          tabIndex={-1}
          className={classNames(classes.button, classes.pasteButton)}
          {...{ 'test-id': ProductGridTestIds.GRID_PASTE_BUTTON }}
        >
          {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_TO_PASTED)}
        </ButtonBase>
      );
    case CopyOrPasteStatusEnum.ON_COPY_SELECTED:
      return (
        <ButtonBase
          disableRipple
          onClick={removeCopiedGrid}
          tabIndex={-1}
          className={classNames(classes.button, classes.copiedGrid)}
        >
          {translate(LangEnum.ORDER_PRODUCTS_GRID_STATUS_COPIED)}
          <Icon icon={X} size="xs" />
        </ButtonBase>
      );

    default:
      return <ButtonOnNoUnableToPaste />;
  }
};

export default CopyOrPasteButton;
